import React, { Fragment } from 'react';
import './Infographic.scss';
import { infographicData } from './infographicData';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import carouselArrow from '../../assets/carousel_arrow.svg';

function InfographicCarousel({ touch }) {
  const arrowStyles = {
    position: 'absolute',
    zIndex: 3,
    top: 'calc(30%)',
    width: 10,
    height: 16,
    border: 'none',
    padding: 0,
    background: 'transparent',
    cursor: 'pointer'
  };
  const indicatorStyles = {
    background: '#004282',
    width: 9,
    height: 9,
    display: 'inline-block',
    margin: '0 5.5px',
    borderRadius: '50%',
    cursor: 'pointer'
  };
  return (
    <Carousel
      showStatus={false}
      showThumbs={false}
      showArrows={touch ? false : true}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
          <button
            type="button"
            onClick={() => {
              onClickHandler();
              window.dataLayer.push({ event: 'carousel_click' });
            }}
            title={label}
            style={{ ...arrowStyles, left: 12 }}
          >
            <img src={carouselArrow} className="carousel__arrows carousel__arrows-left" alt="" />
          </button>
        )
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
        hasNext && (
          <button
            type="button"
            onClick={() => {
              onClickHandler();
              window.dataLayer.push({ event: 'carousel_click' });
            }}
            title={label}
            style={{ ...arrowStyles, right: 12 }}
          >
            <img src={carouselArrow} className="carousel__arrows" alt="" />
          </button>
        )
      }
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <li
              style={{ ...indicatorStyles, background: '#006BB7' }}
              aria-label={`Selected: ${label} ${index + 1}`}
              title={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <li
            style={indicatorStyles}
            onClick={() => {
              onClickHandler();
              window.dataLayer.push({ event: 'carousel_click' });
            }}
            onKeyDown={() => {
              onClickHandler();
              window.dataLayer.push({ event: 'carousel_click' });
            }}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            aria-label={`${label} ${index + 1}`}
          />
        );
      }}
    >
      {infographicData.map(
        ({ photo, type, number, copy, photo1, photo2, type1, type2, number1, number2 }, i) => {
          return (
            <Fragment key={i}>
              {i === 3 ? (
                <div className="carousel__contents__graphics">
                  <div className="carousel__contents__graphic carousel__contents__graphic-3 carousel__contents__graphic-left">
                    <img src={photo1} alt="" className="carousel__contents__graphic__img" />
                    <span className="carousel__contents__graphic__type">{type1}</span>
                    <div className="carousel__contents__graphic__number">{number1}%</div>
                    <p>{copy}</p>
                  </div>
                  <div className="carousel__divider" />
                  <div className="carousel__contents__graphic carousel__contents__graphic-3 carousel__contents__graphic-right">
                    <img src={photo2} alt="" className="carousel__contents__graphic__img" />
                    <span className="carousel__contents__graphic__type">{type2}</span>
                    <div className="carousel__contents__graphic__number">{number2}%</div>
                    <p>{copy}</p>
                  </div>
                </div>
              ) : (
                <div className="carousel__contents__graphic carousel__contents__graphic-single">
                  <img src={photo} alt="" className="carousel__contents__graphic__img" />
                  <span className="carousel__contents__graphic__type">{type}</span>
                  <div className="carousel__contents__graphic__number">{number}%</div>
                  <p>{copy}</p>
                </div>
              )}
            </Fragment>
          );
        }
      )}
    </Carousel>
  );
}

export default InfographicCarousel;
